export default __webpack_public_path__ + "static/media/home-design-agency-bg-img-01.fa1942be.jpg";